import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const MainMenuItem = ({
  url,
  tooltip,
  iconUrl,
  iconAlt,
  accessLevels,
  isExternalLink,
}) => {
  const location = useLocation();
  const firstLinkUrlPathname = url;
  const firstPageUrlPathname = location.pathname;
  const isActive = firstLinkUrlPathname === firstPageUrlPathname;
  return (
    <>
      {/* {accessLevels.includes(accessLevel) && ( */}
      <>
        {isExternalLink && (
          <a
            href={url}
            data-tool-tip={tooltip}
            target='_blank'
            rel='noopener noreferrer'
          >
            {' '}
            <img src={iconUrl} alt='' />
          </a>
        )}
        {!isExternalLink && (
          <Link
            to={url}
            className={clsx(isActive && 'active')}
            data-tool-tip={tooltip}
          >
            <img src={iconUrl} alt='' />
          </Link>
        )}
      </>
      {/* )} */}
    </>
  );
};

MainMenuItem.propTypes = {
  url: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  iconUrl: PropTypes.string.isRequired,
  iconAlt: PropTypes.string.isRequired,
};

export default React.memo(MainMenuItem);
